import { useMemo } from "react"
import { useHttp } from "../use-http"
import { appConstants } from "../../appConstants"

interface IniesHook {
  getOrganismNamesList(): Promise<string[]>
}

export function useInies(): IniesHook {
  const { get } = useHttp()

  return useMemo(
    () => ({
      getOrganismNamesList(): Promise<string[]> {
        return get(appConstants.apiEndpoints.INIES_ORGANISM_LIST).then((response) => response.json())
      },
    }),
    [get]
  )
}
